









































import { Component, Mixins, Prop } from "vue-property-decorator";
import { DocumentTabMixin } from "./mixins";
import { PdfStyleDrawableMixin } from "../../../system/mixins";
import { DomainRegistry } from "../../../../domain";
import { ButtonInfo } from "../../../../domain/workflow/items";
import { WorkflowDocumentKinds, ReceptionCommentKinds } from "../../../../domain/workflow/kinds";
import { DocumentSummary } from "../../../../domain/document";
import { ReferenceFileViewMixin } from "../../../document/mixins";

import PdfViewer from "../../../system/viewers/PdfViewer.vue";
import ReferenceFileSelectDialog from "../../../document/editor/dialogs/ReferenceFileSelectDialog.vue";
import WorkflowActionConfirmDialog from "../../dialogs/WorkflowActionConfirmDialog.vue";
import { ReceptionReference } from "../../../../domain/workflow/reference";
import { MultiOrderableUserListSelectorDialog } from "../../../user/dialogs";
import Enumerable from "linq";

@Component({
  components: {
    PdfViewer,
    ReferenceFileSelectDialog,
    WorkflowActionConfirmDialog,
  }
})
export default class DocumentTab extends Mixins(DocumentTabMixin, PdfStyleDrawableMixin, ReferenceFileViewMixin) {
  $refs!: {
    referenceFileSelectDialog: ReferenceFileSelectDialog,
  };

  @Prop({default: true})
  showPreview: boolean;

  @Prop()
  isSendBackAndEditButtonEnable: boolean;

  get isPreviewableLikeEditing(): boolean {
    return this.$configuration.behavior.document.list.menu.previewLikeEditing.isEnable && this.permittedShowDocument && !this.isUnmanaged;
  }

  get multiOrderableListSelectDialog(): MultiOrderableUserListSelectorDialog {
    return this.$commonDialogs.user.multiOrderableListSelector as MultiOrderableUserListSelectorDialog;
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  async showPreviewPdfLikeEditing(): Promise<void> {
    const result = await this.checkDocumentPermission(this.document);
    if (!result) { return; }

    const repository = DomainRegistry.document.getDocumentRepository();
    const source = await repository.createPreviewLikeEditingSource(this.document.id, this.document.patientNo, this.document.edition);
    const param: any = {
      name: this.document.documentName,
      encodedUri: encodeURIComponent(source.source),
    };
    return this.$openWindow("/ShowDocumentSimply", param);
  }

  async checkDocumentPermission(document: DocumentSummary): Promise<boolean> {
    try {
      // TODO: 現状では参照不可の文書でここに到達することは無いようだが、isReadableの判定もしておいたほうがよい？
      const result = await this.isConfirmedReadable(document);
      if (!result) { return false; }
      await this.checkLogin(document);
      await this.checkWriteAuditLog(document);

      return true;
    } catch (e) {
      // confirm で いいえを押すと飛んでくる？
      console.log("dialog cancel?");
      return false;
    }
  }

  async checkLogin(document: DocumentSummary): Promise<void> {
    console.log("checkLogin");
    if (this.documentShuoldLogin(document)) {
      await this.$commonDialogs.authentication.authenticator.show();
    }
  }

  // 文書参照
  async showDocument(): Promise<void> {

    const result = await this.checkDocumentPermission(this.document);
    if (!result) { return; }

    const param: any = {
      documentKind: WorkflowDocumentKinds.Document,
      receptionDetailId: this.detail.id,
      patientNo: this.reception.patientInfo.patient.id,
      documentId: this.document.id,
      isReadRestrictionAlreadyHandled: true.toString(),
    };

    this.$openWindow("/ShowWorkflowDocument", param);
  }

  // 文書作成
  createDocument(): void {
    // 新規作成の場合は文書がないから権限チェックしない？

    const param: any = {
      documentKind: WorkflowDocumentKinds.Document,
      receptionDetailId: this.detail.id,
      formatId: this.detail.format.id,
      patientNo: this.reception.patientInfo.patient.id
    };

    this.$openWindow("/EditNewWorkflowDocument", param);
  }

  // 文書引用
  async quoteDocument(): Promise<void> {
    // 権限チェックする
    const result = await this.checkDocumentPermission(this.quoteSourceDocument);
    if (!result) { return; }

    const param: any = {
      documentKind: WorkflowDocumentKinds.Document,
      receptionDetailId: this.detail.id,
      patientNo: this.reception.patientInfo.patient.id,
      quotedDocumentId: this.quoteSourceDocument.id,
      formatId: this.detail.format.id,
    };

    this.$openWindow("/EditNewQuotedWorkflowDocument", param);
  }

  // 文書編集
  async editDocument(): Promise<void> {
    return this.editWorkflowWithReceptionReference(this.reference);
  }

  async editWorkflowWithReceptionReference(reference: ReceptionReference): Promise<void> {
    const result = await this.checkDocumentPermission(reference.document);
    if (!result) { return; }

    const param: any = {
      documentKind: WorkflowDocumentKinds.Document,
      receptionDetailId: reference.receptionDetail.id,
      patientNo: reference.reception.patientInfo.patient.id,
      documentId: reference.document.id,
      isReadRestrictionAlreadyHandled: true.toString(),
    };

    this.$openWindow("/EditWorkflowDocument", param);
  }

  async confirmWorkflowAction(permission: ButtonInfo, shouldPrintDocument: boolean = false, actioned: () => Promise<void> = null, shouldSelectPrinter: boolean = false): Promise<void> {
    console.log("confirmWorkflowAction", permission);
    if (this.reference.document) {
      const repository = DomainRegistry.document.getDocumentRepository();
      const editTokens = await repository.getCurrentEditTokens(this.reference.document.id);
      if (editTokens && 0 < editTokens.length) {
        const result = await this.workflowActionConfirmDialog.show(editTokens, permission.buttonName, permission.confirmMessage);
        if (!result) { return; }
      }
    }

    const dialog = await this.workflowActionDialog.show({
      actionPermission: permission,
      nextMessagePermission: this.nextMessagePermission,
      nextMessage: this.nextMessage,
      backMessagePermission: this.backMessagePermission,
      reference: this.commentSet
        ? {
          labelSetting: this.labelSetting,
          comments: {
            defaultSortType: this.commentDefaultSortType,
            shouldSortCommentAsc: this.shouldSortCommentAsc,
            nextMessages: {
              unit: this.nextMessageUnitKind,
              comments: this.commentSet.nextMessages,
            },
            backMessages: {
              unit: this.commentUnitKind,
              comments: this.commentSet.backMessages,
            },
          }
        }
        : null,
    });
    if (dialog.isConfirmed) {
      const isSendBack = permission.destinations.length > 0;
      const backMessagePermitted = this.backMessagePermission ? this.backMessagePermission.isPermitted : false;
      const commentKind = isSendBack && backMessagePermitted
        ? ReceptionCommentKinds.BackMessage
        : ReceptionCommentKinds.NextMessage;
      this.doWorkflowAction(permission, dialog.selectedDestination, dialog.nextMessage, dialog.backMessage, shouldPrintDocument, shouldSelectPrinter, actioned, commentKind, this.nextMessageCommentId, this.nextMessageArchiveId);
    }
  }

  async confirmWorkflowActionAndEditDocument(permission: ButtonInfo): Promise<void> {
    console.log("confirmWorkflowActionAndEditDocument", permission);
    const reference = this.reference;
    this.confirmWorkflowAction(permission, false, async () => this.editWorkflowWithReceptionReference(reference));
  }

  // 他医依頼
  requestAnother(permission: ButtonInfo): void {
    console.log("requestAnother", permission);

    const managers = Enumerable.from(this.detail.managers).select(m => m.staff).toArray();
    this.multiOrderableListSelectDialog.selectOptionsRequiredConditionally(this.requestAnotherCondition, managers, this.detail.documentFixPahseProcessedManagers)
      .then(o => {
        if (o !== undefined) {
          this.updateManagers(o, permission.buttonName);
        }
      });
  }

  showReferenceFiles(): void {
    if (this.reference.documentReferenceFiles.length === 1) {
      this.openReferenceFileViewer(this.reference.documentReferenceFiles[0]);
    } else {
      this.$refs.referenceFileSelectDialog.show(this.reference.documentReferenceFiles, f => this.openReferenceFileViewer(f));
    }
  }
}
